import { render, staticRenderFns } from "./League.vue?vue&type=template&id=ec4e3680"
import script from "./League.vue?vue&type=script&lang=js"
export * from "./League.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports